/**
 * HubSpot Deal Stage Enums
 * 
 * These values are the internal IDs used by HubSpot for filtering and API operations.
 * Last updated: 2025-08-03
 * 
 * To update these values:
 * 1. Call the /api/hubspot/pipelines/deals endpoint
 * 2. Copy the generated enum code from the response
 * 3. Replace the enums below
 */

export enum HubSpotDealStage {
  CONTRACT_SENT = '962003457',
  CONTRACT_SIGNED = '962003459',
  DEAL_LOST = '962003460',
  IN_DISCUSSIONS = '985365664',
  INVOICE_PAID = '972312375',
  INVOICE_SENT = '996553027',
  LEAD_ASSIGNED = '972145803',
  LEAD_GENERATED = '962213552',
  MODEL_BUILD_OUT_IN_PROCESS = '972312369',
  PROJECT_CANCELLED_NO_INVOICE = '984982787',
  PROJECT_COMPLETE = '977672589',
  PROJECT_IN_PROGRESS = '977672588',
  READY_FOR_APPRAISER = '972312370',
  READY_FOR_INVOICING = '1023676675',
  READY_FOR_MODEL_BUILD_OUT = '972312368',
  READY_TO_BEGIN = '991551058',
  REPORT_CREATION_IN_PROGRESS = '972312371',
  REPORT_DELIVERED = '972312373',
  REPORT_IN_REVIEW = '972312372',
  RETAINER_PAID = '990575212',
  SUBMITTED_TO_BID_PORTAL = '985661477',
  WAITING_FOR_CLIENT_DOCUMENTS = '972312367',
}

// Stage label mapping for display purposes
export const HubSpotDealStageLabels: Record<string, string> = {
  '962213552': 'Lead Generated',
  '972145803': 'Lead Assigned',
  '985365664': 'In Discussions',
  '985661477': 'Submitted to Bid Portal',
  '962003457': 'Contract Sent',
  '962003459': 'Contract Signed',
  '996553027': 'Invoice Sent',
  '990575212': 'Retainer Paid',
  '962003460': 'Deal Lost',
  '972312367': 'Waiting for Client Documents',
  '972312368': 'Ready for Model Build Out',
  '972312369': 'Model Build Out In Process',
  '972312370': 'Ready for Appraiser',
  '972312371': 'Report Creation In Progress',
  '972312372': 'Report In Review',
  '972312373': 'Report Delivered',
  '972312374': 'Invoice Sent',
  '972312375': 'Invoice Paid',
  '984982787': 'Project Cancelled - No Invoice',
  '985844480': 'Lead Generated',
  '977679140': 'Lead Assigned',
  '977679143': 'In Discussions',
  '977679144': 'Contract Sent',
  '977679145': 'Contract Signed',
  '1001220417': 'Invoice Sent',
  '991588616': 'Retainer Paid',
  '977679146': 'Deal Lost',
  '991551058': 'Ready to Begin',
  '977672588': 'Project in Progress',
  '977672589': 'Project Complete',
  '1023676675': 'Ready for Invoicing',
  '991551059': 'Invoice Sent',
  '991578017': 'Invoice Paid',
  '985330816': 'Project Cancelled - No Invoice',
};

// Helper function to get stage ID by label
export function getDealStageIdByLabel(label: string): string | undefined {
  const entry = Object.entries(HubSpotDealStageLabels).find(
    ([_, stageLabel]) => stageLabel.toLowerCase() === label.toLowerCase()
  );
  return entry ? entry[0] : undefined;
}

// Helper function to get stage label by ID
export function getDealStageLabelById(id: string): string {
  return HubSpotDealStageLabels[id] || id;
}

// Pipeline information
export const HubSpotPipelines = {
  APPRAISAL_BID: '653966143',
  APPRAISAL_PRODUCTION: '660500996',
  MARKET_COMPASS_SALES: '654252002',
} as const;